<div class="profile">
    <div class="profile-header">
        <img
            [src]="'data:image/png;base64,' + userProfile?.profileImage"
            #img
            (error)="img.src = '../assets/images/profileLogo.svg'"
            alt="profile"
        />
        <div>
            <p class="user-name">{{ userProfile?.name }}</p>
            <p class="user-role">
                {{ userProfile?.email }}
                <span class="change-btn" (click)="onAction('email')">
                    ({{ 'change' | translate }})
                </span>
            </p>
        </div>
    </div>

    <div class="profile-content">
        <div class="profile-roles">
            <mat-accordion>
                <mat-expansion-panel
                    class="mat-elevation-z0"
                    (click)="$event.stopPropagation()"
                >
                    <mat-expansion-panel-header
                        collapsedHeight="48px"
                        expandedHeight="48px"
                    >
                        <mat-panel-title>
                            <img src="../assets/images/rolesLight.svg" alt="" />
                            <p>{{ 'roles' | translate }}</p>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="profile-roles-list">
                        @for (role of userRoles; track $index) {
                            <p [ngClass]="{ 'active-role': true }">
                                {{ role.split('-').join(' ') | titlecase }}
                            </p>
                        }
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </div>

    <div class="logout-section border-bottom" (click)="openRoleRequest()">
        <img src="../assets/images/roleRequestLight.svg" alt="" />
        <h1>{{ 'roleRequest' | translate }}</h1>
    </div>

    <div
        class="logout-section border-bottom"
        (click)="onAction('changePassword')"
    >
        <img src="../assets/images/changePassword.svg" alt="" />
        <h1>{{ 'changePassword' | translate }}</h1>
    </div>

    <div class="profile-content">
        <div class="profile-roles">
            <mat-accordion>
                <mat-expansion-panel
                    class="mat-elevation-z0"
                    (click)="$event.stopPropagation()"
                >
                    <mat-expansion-panel-header
                        collapsedHeight="48px"
                        expandedHeight="48px"
                    >
                        <mat-panel-title>
                            <img
                                src="../assets/images/helpSupport.svg"
                                alt=""
                            />
                            <p>{{ 'helpSupport' | translate }}</p>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="profile-roles-list">
                        @for (
                            support of [
                                'ticketSupport',
                                'emailSupport',
                                'faqs',
                                'userManual',
                            ];
                            track $index
                        ) {
                            <p>{{ support | translate }}</p>
                        }
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </div>

    @if (!isTOTPConfigured) {
        <div class="logout-section border-bottom" (click)="onAction('totp')">
            <img src="../assets/images/changePassword.svg" alt="" />
            <h1>{{ 'configureTotp' | translate }}</h1>
        </div>
    }

    @if (!isPasswordLessAuthConfigured) {
        <div
            class="logout-section border-bottom"
            (click)="onAction('passwordLess')"
        >
            <img src="../assets/images/changePassword.svg" alt="" />
            <h1>{{ 'configurePasswordLessAuthentication' | translate }}</h1>
        </div>
    }

    <div class="logout-section" (click)="logout()">
        <img src="../assets/images/logout.svg" alt="" />
        <h1>{{ 'logout' | translate }}</h1>
    </div>
</div>
